//messages.js
export default {
    people_id: "People ID",
    prefix: "Prefix",
    first_name: "First Name",
    middle_name: "Middle Name",
    last_name: "Last Name",
    suffix: "Suffix",
    combined_name: "Combined Name",
    nick_name: "Nick Name",
    job_title: "Job Title",
    gender: "Gender",
    photo_id: "Photo ID",
    photo: "Photo",
    entity_phones_id: "Entity Phones ID",
    entity_emails_id: "Entity Emails ID",
    battery_notify: "Battery Notify",
    user_time_zone: "User Time Zone",
    unit_of_measure: "Unit Of Measure",
    theme: "Theme",
    notification_method: "Notification Method",
    language: "Language",
    invite_token: "Invite Token",
    invite_expires: "Invite Expires",
    edit_person: "Edit Person",
    add_person: "Add Person",
    delete_person: "Delete Person",
    people: "People",
    delete_person_confirm: "This action is not reversible!",
    device_tags_filter: "Device Tags Filter",
    filters_and_permissions: "Filters & Permissions",
    "customer - Read Only": "Read Only",
    report_time: "Report Time",
    default_route: "Default Route",
};
